import * as types from './mutation-types'

export default {
    [types.FILES_UPDATED](state, files) {
        state.data = files
    },
    [types.FILES_UPLOAD_STARTED](state) {
        state.uploadInProgress = true
    },
    [types.FILES_UPLOAD_OK](state) {
        state.uploadInProgress = false
        state.uploadProgress = 0
    },
    [types.FILES_UPLOAD_ERROR](state) {
        state.uploadInProgress = false
        state.uploadProgress = 0
    },
    [types.UPLOAD_PROGRESS_UPDATED](state, uploadProgress) {
        state.uploadProgress = uploadProgress;
    },
    [types.FILE_DOWNLOAD_RECEIVED]() { },
    [types.FILE_DOWNLOAD_ERROR]() { }
}
